import React from 'react'
import { Logo } from '../Logo'
import NavigationBar from '../../components/Header/menu/NavigationBar'
import GeneralSearch from '../../components/Header/GeneralSearch'
import { SearchViaAiButton } from '../../components/Header/SearchViaAiButton'
import { UserWidget } from '../../components/Header/UserWidget'
import { MessageWidget } from '../../components/Header/MessageWidget'
import { CartWidget } from '../../components/Header/CartWidget'
import { Link } from 'react-router-dom'
import { Col, Container, Row } from 'react-bootstrap'
import { HorizontalStack } from '@ztechapps/webui.util'

export const DesktopHeader = () => {
  return (
    <React.Fragment>
      <header className="py-2 bg-primary d-none d-lg-block">
        <section>
          <Container>
            <Row className="align-items-center">
              <Col lg={3} sm={6}>
                <div>
                  <Link to="/">
                    <Logo />
                  </Link>
                </div>
              </Col>
              <Col lg={5}>
                <HorizontalStack gap={2}>
                  <div className="flex-grow-1">
                    <GeneralSearch />
                  </div>
                  <SearchViaAiButton />
                </HorizontalStack>
              </Col>

              <Col lg={4}>
                <HorizontalStack gap={2} className="justify-content-end">
                  <CartWidget />
                  <MessageWidget />
                  <UserWidget />
                </HorizontalStack>
              </Col>
            </Row>
          </Container>
        </section>
      </header>
      <div className="d-none d-lg-block">
        <NavigationBar />
      </div>
    </React.Fragment>
  )
}
